import { AmplitudeFeatureFlag } from '@genoa/experiments'

import { useAmplitude } from '../providers'

export function useAmplitudeFeatureFlag(key: AmplitudeFeatureFlag) {
  const { isFeatureFlagEnabled, experimentLoaded } = useAmplitude()
  return { enabled: isFeatureFlagEnabled(key), isLoaded: experimentLoaded }
}
